<template>
  <div class="odmik-naroci-televizija">
    <div v-if="!prikaziSamoStoritve">
      <div v-if="seznamProgramskihShemNov.length > 0">
        <div>
          <ul>
            <li>
              <img src="/static/img/Naroci/NarociTelevizija/Icon-material-featured-play-list.png">
              <span class="open-sans-20pt">
                Programske sheme
            </span>
            </li>
          </ul>
        </div>
      </div>
      <div style="padding-top: 20px" v-if="seznamProgramskihShemNov.length > 0">
        <p class="navadno-besedilo">
          Si v prostem času radi privoščite res dobro TV vsebino? Poskrbite, da vas čaka na vašem ekranu. Izberite
          pravo TV programsko shemo.
          <br>
          Preverite primerjalnik
          <a :href="povezavaPrimerjalnikProgramskihShem" class="primarna-barva">programskih shem</a>.
        </p>
      </div>

      <izdelki-box class="pt-6" v-loading="NalaganjeTvShem">
        <izdelek
          v-for="ps in seznamProgramskihShemNov"
          :title="ps.naziv.toUpperCase()"
          :tag="ps.vPaketu === 1 ? 'VKLJUČENO V PAKET' : null"
          :key="ps.idStoritevVrstaIzbira"
        >
          <template v-slot:footer>
            <div class="cena">{{formatPrice(ps.vPaketu === 1 ? 0 : ps.cena)}} / mesec</div>
            <div class="orderButtonContainer">
              <template v-if="ps.vPaketu === 0">
                <OrderButton
                  v-show="ps.vklopljeno === 0 && ps.naroceno === 0 && ps.horizontMoznaIzbira === 1"
                  :services="[{serviceId: ps.id, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                  :service-name="'programsko shemo: ' + ps.naziv.toUpperCase()"
                  style="width: 170px;"
                  @orderConfirmed="$emit('reloadPodatkov')"
                >
                  VKLOPI SHEMO
                </OrderButton>
                <OrderButton
                  v-show="ps.vPaketu === 0 && ps.vklopljeno === 1"
                  :services="[{serviceId: ps.id, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                  :service-name="'programsko shemo: ' + ps.naziv.toUpperCase()"
                  style="width: 170px;"
                  @orderConfirmed="$emit('reloadPodatkov')"
                >
                  ODJAVI SHEMO
                </OrderButton>
                <div v-if="ps.vPaketu === 1 && ps.vklopljeno === 1 && ps.horizontMoznaIzbira === 1">
                  <el-button class="gumb-potrdi" disabled="disabled" style="display: flex; justify-content: center; width: 170px;">
                    V PAKETU
                  </el-button>
                </div>
                <div v-if="ps.vklopljeno === 0 && ps.horizontMoznaIzbira === 0">
                  <el-button class="gumb-ni-na-voljo" disabled="disabled" style="display: flex; justify-content: center; width: 170px;">
                    VKLOPI SHEMO
                  </el-button>
                </div>
                <div v-if="ps.vklopljeno === 0 && ps.naroceno === 1">
                  <a class="okvir-odjave tekst-okvir-odjava" style="cursor: default; width: 170px;">
                    NAROČILO V TEKU
                  </a>
                </div>
              </template>
              <template v-else>
                <el-button
                  class="gumb-potrdi"
                  :disabled="ps.naroceno === 1 || ps.vklopljeno === 1"
                  :loading="ps.loading"
                  @click="NarociTvSheme(ps.id, 1, ps.naziv, ps)"
                >
                  {{ps.vklopljeno === 1 ? 'SHEMA VKLOPLJENA' : (ps.naroceno === 1 ? 'NAROČILO V TEKU' : 'VKLOPI SHEMO')}}
                </el-button>
              </template>
            </div>
            <div v-if="ps.vPaketu === 1" class="rednaCena">Redna cena: {{formatPrice(ps.cena)}} / mesec</div>
          </template>
          <div class="px-2" style="text-align: justify;">{{ps.opis}}</div>
        </izdelek>
      </izdelki-box>
      <div style="padding-top: 50px; padding-bottom: 30px">
        <hr class="hr-stil">
      </div>
    </div>
    <div v-if="seznamDodatnihPaketov.length > 0">
      <TVstoritve :izbranPrikljucek="izbranPrikljucek"
                  :seznamDodatnihPaketov="seznamDodatnihPaketov"
                  v-on:narociTvStoritve="NarociNovPaket"
                  @reloadPodatkov="$emit('reloadPodatkov')"
      />
    </div>
    <div style="padding-top: 40px">
      <InfoKomponenta/>
    </div>
    <OrderExistsInfo v-if="orderExists"/>
  </div>
</template>
<script>
  import Vue from 'vue'
  import ClientAgent from '../../../../../assets/js/clientAgent.js'
  import {Button, Col} from 'element-ui'
  import {povezave} from '../../../../../assets/js/Povezave/povezave'
  import InfoKomponenta from './InfoKomponenta'
  import TVstoritve from '../NarociTelevizija/TVstoritve.vue'
  import OrderButton from '../../../../UIComponents/OrderButton.vue'
  import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'
  import Izdelek from '../../../../UIComponents/Izdelki/Izdelek.vue'
  import IzdelkiBox from '../../../../UIComponents/Izdelki/IzdelkiBox.vue'
  import {SlovenianCurrencyMixin} from '../../../../../assets/js/Helpers/NumberFormatMixin'

  export default {
    name: 'TVsheme',
    emits: ['reloadPodatkov', 'narociTvSheme', 'narociNovPaketTvStoritve'],
    mixins: [SlovenianCurrencyMixin],
    data () {
      return {
        orderExists: false,
        SeznamTvShem: [],
        NalaganjeTvShem: false,
        seznamVklopljenih: [],
        povezavaPrimerjalnikProgramskihShem: '',
        seznamProgramskihShemNov: []
      }
    },
    props: {
      izbranPrikljucek: null,
      seznamProgramskihShem: null,
      seznamDodatnihPaketov: null,
      prikaziSamoStoritve: {
        type: Boolean,
        default: false
      }
    },
    components: {
      IzdelkiBox,
      Izdelek,
      OrderExistsInfo,
      OrderButton,
      InfoKomponenta,
      [Button.name]: Button,
      [Col.name]: Col,
      'TVstoritve': TVstoritve
    },
    watch: {
      izbranPrikljucek: function () {
        if (this.izbranPrikljucek !== null) {
          this.SeznamTvShem = []
        }
      },
      seznamProgramskihShem: function (val) {
        this.KopirajProgramskeSheme()
      }
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.povezavaPrimerjalnikProgramskihShem = povezave.BASE_URL_PRIMERJALNIK_PROGRAMSKIH_SHEM
      this.KopirajProgramskeSheme()
    },
    methods: {
      NarociNovPaket (izbranPaketId, status, naziv) {
        this.$emit('narociNovPaketTvStoritve', izbranPaketId, status, naziv)
      },
      NarociTvSheme (izbranPaketId, status, naziv, item) {
        item.loading = true
        this.$emit('narociTvSheme', izbranPaketId, status, naziv)
      },
      async reloadOrderExists () {
        if (this.izbranPrikljucek !== null) {
          let orderExistsTmp = false
          if (this.seznamProgramskihShemNov !== null && Array.isArray(this.seznamProgramskihShemNov)) {
            this.seznamProgramskihShemNov.forEach((s) => {
              if (s.naroceno > 0) {
                orderExistsTmp = true
              }
            })
          }
          if (this.seznamDodatnihPaketov !== null && Array.isArray(this.seznamDodatnihPaketov)) {
            this.seznamDodatnihPaketov.forEach((s) => {
              if (s.naroceno > 0) {
                orderExistsTmp = true
              }
            })
          }
          this.orderExists = orderExistsTmp
        }
      },
      KopirajProgramskeSheme () {
        this.seznamProgramskihShemNov = []
        let i = 0
        for (const index in this.seznamProgramskihShem) {
          if (typeof this.seznamProgramskihShem[index] !== 'undefined' &&
            this.seznamProgramskihShem[index].prikazanoHorizont === 1) {
            Vue.set(this.seznamProgramskihShemNov, i++, this.seznamProgramskihShem[index])
          }
        }
        this.reloadOrderExists()
      }
    }
  }
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/TVsheme.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/TVsheme.vue